import { getWindowObject } from '@eventbrite/feature-detection';
import { TLZEnvironment } from '../models/bff';
import { isQAEnv, isSTAGEEnv } from './browser';

export const getTlzEnv = (isProd: boolean) => {
    if (isProd) {
        return TLZEnvironment.prod;
    }

    const host = getWindowObject('location')?.host;

    if (!host) {
        return TLZEnvironment.dev;
    }

    if (isSTAGEEnv(host)) {
        return TLZEnvironment.preprod;
    }

    return isQAEnv(host) ? TLZEnvironment.qa : TLZEnvironment.dev;
};
